<template>
  <div class="layout">
    <HeaderDoc :doc="doc" />
    <div class="layout__wrapper">
      <slot name="banner"></slot>
      <section class="title-section">
        <div class="container">
          <slot name="page-title">
            <h1 class="title-section__title">{{ doc.title }}</h1>
            <ContentLabel
              v-if="doc.showAiLabel"
              class="doc-preview__content-label"
            />
          </slot>
        </div>
      </section>
      <section
        class="book-reading background-section"
        :class="doc.readingCssClass"
      >
        <div
          :class="doc.controls.containerClass"
          class="container book-reading__content control-container"
        >
          <BackLink class="book-reading__backlink" />
          <Sidebar :doc="doc" :show-text-controls="showTextControls">
            <SidebarTOC
              :doc="doc"
              :class="doc.tutorial ? doc.tutorial.tocBtnClass : ''"
            />
            <SidebarTutorial
              v-if="doc.tutorial && doc.isCurrentFirstPage()"
              :book-tutorial="doc.tutorial"
            />
          </Sidebar>
          <slot name="page-content"> </slot>
        </div>
        <Tutorial
          v-if="doc.tutorial && doc.isCurrentFirstPage()"
          :book-tutorial="doc.tutorial"
        />
        <slot name="page-footer"> </slot>
      </section>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue'

import Sidebar from '@/app/components/doc/reading/Sidebar.vue'
import HeaderDoc from '@/app/components/doc/Header.vue'
import BackLink from '@/app/components/BackLink.vue'

import SidebarTOC from '@/app/components/doc/reading/SidebarTOC.vue'
import SidebarTutorial from '@/app/components/doc/tutorial/SidebarTutorial.vue'
import Tutorial from '@/app/components/doc/tutorial/Tutorial.vue'
import ContentLabel from '@/app/components/doc/ContentLabel.vue'

import { autoShowTutorial } from '@/models/doc.tutorial'
import { DocView } from '@/models/doc'

const props = withDefaults(
  defineProps<{
    doc: DocView
    // Set to false to hide text controls: font settings, audio player button.
    showTextControls?: boolean
  }>(),
  {
    showTextControls: true,
  },
)

onMounted(() => {
  autoShowTutorial(props.doc.tutorial)
})
</script>

<style lang="scss" scoped>
.book-reading {
  &__backlink {
    margin-bottom: 24px;

    @media only screen and (max-width: $w-tablet-s) {
      display: none;
    }
  }
}
</style>
